<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label>Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre de la financiera"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerFinancieras"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Crear configuración" v-if="$localStorageService.can('Fn_01_financiera_crear')" variant="outline-success"
                        @click="agregar()"
              >Crear Financiera
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Modificar Financiera"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                    v-if="$localStorageService.can('Fn_01_financiera_editar')"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button
                    v-if="!row.item.registroActivo && $localStorageService.can('Fn_01_financiera_activar')"
                    title="Activar financiera"
                    variant="outline-success"
                    size="sm"
                    @click="activarDesactivar(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-if="row.item.registroActivo && $localStorageService.can('Fn_01_financiera_activar')"
                          title="Desactivar financiera"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivar(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

      <b-modal
          v-model="show"
          :title="tituloModal"
          size="lg"
      >
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group align="left">
                  <label>Nombre
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input id="nivel" name="nivel" placeholder="Nombre de la financiera"
                                  v-model="$v.financiera.financiera.$model"
                                  :state="validateState('financiera')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-form>
                </b-col>
                <b-col>
                <b-form-group align="left">
                  <div style="display: inline-flex">
                    <div class="text-left" style="margin-right: 16em">
                      <label>Logo </label>
                    </div>
                    <div class="text-right" v-if="imagenVista !== null">
                      <em class="flechasDirecciones_svg"
                          style="width: 22px; cursor: pointer"
                          v-b-tooltip.hover.top.v-light
                          title="Cambiar Logo"
                          @click="quitarImg()"
                      />
                    </div>
                  </div>
                  <div v-if="imagenVista !== null">
                    <img :src="'data:image/png;base64,' + imagenVista " alt="img" />
                  </div>
                  <b-input-group size="sm" class="mb-2" v-else>
                    <b-form-file
                        ref="imagenfinanciera"
                        v-model="imagenVista"
                        placeholder="Selecciona un archivo "
                        drop-placeholder="Selecciona un archivo"
                        browse-text="Abrir"
                        icon="download"
                        accept=".jpg, .png"
                        @change="base64"
                    ></b-form-file>
                  </b-input-group>
                </b-form-group>

            </b-col>
          </b-row>
        </b-container>
        <div slot="modal-footer">
          <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
            <span v-if="!loaderAcciones">Guardar</span>
            <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
          </b-button>
          <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
        </div>
      </b-modal>

    </b-container>
  </div>
</template>

<script>

import {required} from "vuelidate/lib/validators";
export default {
  name: "Financieras",
  data: () => ({
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null
    },
    datosTabla: [],
    fields: [
      { key: "idFinanciera", label: "ID", sortable: true },
      { key: "financiera", label: "Nombre", sortable: true },
      "Acciones",
    ],
    registrosPorPagina: 10,
    paginaActual: 0,
    loader: false,
    tituloModal: '',
    loaderAcciones: false,
    show: false,
    imagenVista: null,
    tipoImagen: null,
    financiera: {
      idFinanciera: null,
      financiera: null,
      comision: null,
      registro: null,
      imagen: null,
      extencionImagen: null,
    },
  }),
  validations: {
    financiera: {
      financiera: {required},
    }
  },
  created() {
    this.obtenerFinancieras();
  },
  methods: {
    quitarImg(){
      this.imagenVista = null;
      this.cambioImg = true;
      if (this.$refs["imagenfinanciera"] != null) {
        this.$refs["imagenfinanciera"].reset();
      }
    },
    base64(e){
        this.cambioImg = true;
        let base = e.target.files || e.dataTransfer.files;
        const file = new Blob([base[0]], {type: "image/png"});
        const extencionImagen = base[0].type.substr(6, 100)

        if (extencionImagen !== 'png' && extencionImagen !== 'jpg' && extencionImagen !== 'jpeg') {
          this.imagenVista = null;
          this.$refs.imagenfinanciera.reset();
        } else {

          /* let img = new Image();*/
          this.tipoImagen = file.type;

          let reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = (e) => {
            let imagen = e.target.result
            let indice = imagen.indexOf(",");
            let base64 = imagen.substring(indice + 1, 100000000);
            this.imagenVista = base64
          };

          if (this.imagenVista.size > 360000) {
            this.$bvToast.toast('No se puede guardar, la imagen es muy pesada. ', {headerClass: 'bg-warning'});
            return;
          }
        }

    },
    obtenerFinancieras() {
      this.loader = true;
      this.$http
          .post(this.$api + "financiera/obtener/filtro", this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    agregar() {
      this.financiera = {
        idFinanciera: null,
        financiera: null,
        comision: null,
        registro: null,
        imagen: null,
      };
      this.tituloModal = 'Agregar Financiera';
      this.imagenVista = null;
      this.show = true;
    },
    guardar(){
      this.$v.financiera.$touch();
      if (this.$v.financiera.$anyError) {
        return;
      }

      if (!this.$v.financiera.$invalid) {
        this.financiera.imagen = this.imagenVista;
        this.financiera.extencionImagen = this.tipoImagen;
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'financiera/guardar', this.financiera).then(respuesta => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La financiera se registró correctamente",
                });
                this.filtro= {
                  id: null,
                  palabraClave: null,
                  registroActivo: null
                }
                this.obtenerFinancieras();
                this.show = false;
              }
            }
        ).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Error al guardar la financiera.",
          });
        }).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }

    },
    modificar(item){
      this.financiera = item;
      this.tituloModal = "Modificar Financiera";
      this.imagenVista = item.imagen;
      this.show = true;
    },
    activarDesactivar(item){
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar la financiera?' : '¿Está seguro de activar la financiera?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idFinanciera: item.idFinanciera,
          }
          this.$http.post(this.$api + 'financiera/desactivarActivar/',  parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "La Financiera se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    cerrarModal() {
      this.show = false;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.financiera[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    }
  }

}
</script>

<style scoped>

</style>
